import { ReactNode } from 'react';
import { DurationInputProps, DurationObject } from '@mews-commander/ui';
import { FormInputField, lt } from '@mews/framework';
import { CompoundField } from '@optimus-web/core';

const orderedDurationUnits: Array<keyof DurationObject> = ['months', 'days', 'hours', 'minutes', 'seconds'];

type DurationSuffixes = Partial<Record<keyof DurationObject, ReactNode>>;

export interface DurationInputFieldProps extends Omit<DurationInputProps, 'error'> {
    suffixes?: DurationSuffixes;
}

export const DurationInputField = ({
    units,
    helper,
    name,
    size,
    autoFocus,
    forwardedRef,
    suffixes,
    ...props
}: DurationInputFieldProps) => {
    const leftMostInput = orderedDurationUnits.find((unit) => units[unit]);

    const createProps = (unit: keyof DurationObject) => ({
        type: 'number',
        name: `${name}.${unit}`,
        size,
        autoFocus: autoFocus && unit === leftMostInput,
        forwardedRef: forwardedRef && unit === leftMostInput ? forwardedRef : undefined,
    });

    return (
        <CompoundField {...props} helper={helper} name={name}>
            {units.months ? (
                <FormInputField {...createProps('months')} suffix={suffixes?.months ?? lt('Months')} />
            ) : null}
            {units.days ? <FormInputField {...createProps('days')} suffix={suffixes?.days ?? lt('Days')} /> : null}
            {units.hours ? <FormInputField {...createProps('hours')} suffix={suffixes?.hours ?? lt('Hours')} /> : null}
            {units.minutes ? (
                <FormInputField {...createProps('minutes')} suffix={suffixes?.minutes ?? lt('Minutes')} />
            ) : null}
            {units.seconds ? (
                <FormInputField {...createProps('seconds')} suffix={suffixes?.seconds ?? lt('Seconds')} />
            ) : null}
        </CompoundField>
    );
};
